import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-8163">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-8164">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-8165">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-8166">
            <ArrowLeft className="w-4 h-4" data-id="element-8167" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-8168">NOIZA</div>
          <div className="w-20" data-id="element-8169" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-8170">
        <div className="mb-12" data-id="element-8171">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-8172">
            <FileText className="w-6 h-6 text-white/80" data-id="element-8173" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-8174">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-8175">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-8176">
          <section data-id="element-8177">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8178">
              <span className="text-[#006847]" data-id="element-8179">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8180">
              <p data-id="element-8181">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-8182">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8183">
                <li data-id="element-8184">Haber leído íntegramente este documento</li>
                <li data-id="element-8185">Comprender su contenido en su totalidad</li>
                <li data-id="element-8186">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-8187">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-8188">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8189">
              <span className="text-[#006847]" data-id="element-8190">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-8191">
              <p data-id="element-8192">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8193">
                <li data-id="element-8194">Software como servicio (SaaS)</li>
                <li data-id="element-8195">Marketplace digital gastronómico</li>
                <li data-id="element-8196">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-8197">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8198">
                <li data-id="element-8199">Mostrar su menú digital</li>
                <li data-id="element-8200">Recibir pedidos de clientes</li>
                <li data-id="element-8201">Gestionar su operación interna</li>
                <li data-id="element-8202">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-8203">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-8204">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8205">
              <span className="text-[#006847]" data-id="element-8206">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8207">
              <p data-id="element-8208">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8209">
                <li data-id="element-8210">No es proveedor de alimentos</li>
                <li data-id="element-8211">No participa en la preparación de productos</li>
                <li data-id="element-8212">No manipula alimentos en ningún momento</li>
                <li data-id="element-8213">No realiza entregas ni logística</li>
                <li data-id="element-8214">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-8215">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-8216">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-8217">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8218">
              <span className="text-[#006847]" data-id="element-8219">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-8220">
              <p data-id="element-8221">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-8222">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8223">
                <li data-id="element-8224">El restaurante es el único responsable de su operación</li>
                <li data-id="element-8225">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-8226">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-8227">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8228">
                <li data-id="element-8229">Precios</li>
                <li data-id="element-8230">Menú</li>
                <li data-id="element-8231">Horarios</li>
                <li data-id="element-8232">Métodos de pago</li>
                <li data-id="element-8233">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8234">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8235">
              <span className="text-[#006847]" data-id="element-8236">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-8237">
              <div data-id="element-8238">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8239">
                  5.1. Alcance general
                </h3>
                <p data-id="element-8240">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-8241">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8242">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-8243">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-8244">
                  <li data-id="element-8245">Calidad de los alimentos</li>
                  <li data-id="element-8246">Estado, frescura o preparación</li>
                  <li data-id="element-8247">Ingredientes utilizados</li>
                  <li data-id="element-8248">Contaminación cruzada</li>
                  <li data-id="element-8249">Problemas de higiene o salubridad</li>
                  <li data-id="element-8250">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-8251">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-8252">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8253">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-8254">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8255">
                  <li data-id="element-8256">Retrasos en la entrega</li>
                  <li data-id="element-8257">Pérdida de pedidos</li>
                  <li data-id="element-8258">Entregas incompletas</li>
                  <li data-id="element-8259">Errores en dirección</li>
                  <li data-id="element-8260">Conducta de repartidores</li>
                  <li data-id="element-8261">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-8262">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8263">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-8264">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-8265">
                  <li data-id="element-8266">Recepción de pagos</li>
                  <li data-id="element-8267">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-8268">Manejo de efectivo</li>
                  <li data-id="element-8269">Confirmación de pagos</li>
                  <li data-id="element-8270">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-8271">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8272">
                  <li data-id="element-8273">Pagos no recibidos</li>
                  <li data-id="element-8274">Comprobantes falsos</li>
                  <li data-id="element-8275">Errores en montos</li>
                  <li data-id="element-8276">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-8277">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8278">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-8279">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-8280">
                  <li data-id="element-8281">Reclamos de clientes</li>
                  <li data-id="element-8282">Reembolsos</li>
                  <li data-id="element-8283">Cancelaciones</li>
                  <li data-id="element-8284">Disputas</li>
                  <li data-id="element-8285">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-8286">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-8287">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8288">
              <span className="text-[#006847]" data-id="element-8289">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-8290">
              <p data-id="element-8291">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8292">
                <li data-id="element-8293">Responsable</li>
                <li data-id="element-8294">Legal</li>
                <li data-id="element-8295">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-8296">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8297">
                <li data-id="element-8298">Publicar información falsa</li>
                <li data-id="element-8299">Manipular precios de forma engañosa</li>
                <li data-id="element-8300">Simular disponibilidad inexistente</li>
                <li data-id="element-8301">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8302">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8303">
              <span className="text-[#006847]" data-id="element-8304">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-8305">
              <p data-id="element-8306">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8307">
                <li data-id="element-8308">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-8309">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-8310">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8311">
                <li data-id="element-8312">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-8313">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-8314">
                    <li data-id="element-8315">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-8316">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-8317">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8318">
              <span className="text-[#006847]" data-id="element-8319">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-8320">
              <p data-id="element-8321">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8322">
                <li data-id="element-8323">Menú digital</li>
                <li data-id="element-8324">Gestión de pedidos</li>
                <li data-id="element-8325">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-8326">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-8327">
                  <p className="font-medium text-white mb-2" data-id="element-8328">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8329">
                    <li data-id="element-8330">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-8331">
                  <p className="font-medium text-white mb-2" data-id="element-8332">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8333">
                    <li data-id="element-8334">Propiedad del software</li>
                    <li data-id="element-8335">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-8336">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-8337">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8338">
              <span className="text-[#006847]" data-id="element-8339">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-8340">
              <p data-id="element-8341">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8342">
                <li data-id="element-8343">Disponibilidad continua</li>
                <li data-id="element-8344">Funcionamiento sin interrupciones</li>
                <li data-id="element-8345">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-8346">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8347">
                <li data-id="element-8348">Fallas técnicas</li>
                <li data-id="element-8349">Actualizaciones</li>
                <li data-id="element-8350">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-8351">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-8352">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8353">
              <span className="text-[#006847]" data-id="element-8354">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-8355">
              <p data-id="element-8356">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8357">
                <li data-id="element-8358">No está garantizada permanentemente</li>
                <li data-id="element-8359">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-8360">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8361">
                <li data-id="element-8362">Destacar o no restaurantes</li>
                <li data-id="element-8363">Modificar posiciones</li>
                <li data-id="element-8364">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8365">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8366">
              <span className="text-[#006847]" data-id="element-8367">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-8368">
              <p data-id="element-8369">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8370">
                <li data-id="element-8371">Cumplir con los pagos acordados</li>
                <li data-id="element-8372">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-8373">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8374">
                <li data-id="element-8375">Suspender el servicio</li>
                <li data-id="element-8376">Limitar funcionalidades</li>
                <li data-id="element-8377">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8378">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8379">
              <span className="text-[#006847]" data-id="element-8380">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8381">
              <p data-id="element-8382">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8383">
                <li data-id="element-8384">Incumplimiento de términos</li>
                <li data-id="element-8385">Uso indebido</li>
                <li data-id="element-8386">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-8387">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-8388">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8389">
              <span className="text-[#006847]" data-id="element-8390">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-8391">
              <p data-id="element-8392">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-8393">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-8394">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8395">
              <span className="text-[#006847]" data-id="element-8396">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-8397">
              <p data-id="element-8398">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8399">
                <li data-id="element-8400">Pérdidas económicas</li>
                <li data-id="element-8401">Daños indirectos</li>
                <li data-id="element-8402">Lucro cesante</li>
                <li data-id="element-8403">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8404">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8405">
              <span className="text-[#006847]" data-id="element-8406">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-8407">
              <p data-id="element-8408">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-8409">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8410">
              <span className="text-[#006847]" data-id="element-8411">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-8412">
              <p className="font-medium" data-id="element-8413">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-8414">
                <li data-id="element-8415">Ha leído este documento completo</li>
                <li data-id="element-8416">Comprende su alcance</li>
                <li data-id="element-8417">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}